// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the 
// presence of a DOM element with a given data attribute. 

// This file is loaded globally but should just contain dynamically 
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// --------------------------------
if (true) {
	import('./main')
	.then(({ mainJs }) => {
		mainJs()
	})
}

// --------------------------------
// Stick the navbar to the top
// --------------------------------
const navigations = document.querySelectorAll('[data-module="sticky-navigation"]')

if (navigations.length > 0) {
  import('./animation/sticky-navigation')
    .then(({ stickyNavigation }) => {
			navigations.forEach(navigation => {
				stickyNavigation(navigation)
			})
		})
}

// --------------------------------
// Stick the navbar to the top
// --------------------------------
const pagination = document.querySelectorAll('.pagination')

if (pagination.length > 0) {
  import('./animation/load-more')
    .then(({ loadMore }) => {
			pagination.forEach(button => {
				loadMore(button)
			})
		})
}

// --------------------------------
// Sticky back button on scroll
// --------------------------------
const backButtons = document.querySelectorAll('[data-module="sticky-back-button"]')

if (backButtons.length > 0) {
  import('./animation/sticky-back-button')
    .then(({ stickyBackButton }) => {
			backButtons.forEach(button => {
				stickyBackButton(button)
			})
		})
}

// --------------------------------
// Animation to reveal header share menu
// --------------------------------
const headerShareMenus = document.querySelectorAll('[data-module="header-share-menu"]')

if (headerShareMenus.length > 0) {
  import('./animation/header-share-menu')
    .then(({ headerShareMenu }) => {
			headerShareMenus.forEach(menu => {
				headerShareMenu(menu)
			})
		})
}

// --------------------------------
// Handle video lightboxes
// --------------------------------
const videoLightboxTriggers = document.querySelectorAll('[data-module="video-lightbox-trigger"]')

if (videoLightboxTriggers.length > 0) {
  import('./components/video-lightbox')
    .then(({ videoLightbox }) => {
			videoLightboxTriggers.forEach(lightboxTrigger => {
				videoLightbox(lightboxTrigger)
			})
		})
}

// --------------------------------
// Handle form lightboxes
// --------------------------------
const formLightboxTriggers = document.querySelectorAll('[data-module="form-lightbox-trigger"]')

if (formLightboxTriggers.length > 0) {
  import('./components/form-lightbox')
    .then(({ formLightbox }) => {
			formLightboxTriggers.forEach(lightboxTrigger => {
				formLightbox(lightboxTrigger)
			})
		})
}

// --------------------------------
// Handle gallery lightboxes
// --------------------------------
const galleryLightboxTriggers = document.querySelectorAll('[data-module="gallery-lightbox-trigger"]')

if (galleryLightboxTriggers.length > 0) {
  import('./components/gallery-lightbox')
    .then(({ galleryLightbox }) => {
			galleryLightboxTriggers.forEach(lightboxTrigger => {
				galleryLightbox(lightboxTrigger)
			})
		})
}

// --------------------------------
// Scroll to section from navigation links
// --------------------------------
const navigationLinks = document.querySelectorAll('[data-module="navigation-scroll"]')

if (navigationLinks.length > 0) {
  import('./components/navigation-scroll')
    .then(({ navigationScroll }) => {
			navigationLinks.forEach(navigation => {
				navigationScroll(navigation)
			})
		})
}

// --------------------------------
// Scroll to section from navigation links from mobile menu
// --------------------------------
const mobileNavigationLinks = document.querySelectorAll('[data-module="mobile-navigation-scroll"]')

if (mobileNavigationLinks.length > 0) {
  import('./components/mobile-navigation-scroll')
    .then(({ mobileNavigationScroll }) => {
			mobileNavigationLinks.forEach(navigation => {
				mobileNavigationScroll(navigation)
			})
		})
}

// --------------------------------
// Handle the active classes on the scroll rig
// --------------------------------
const rigEl = document.querySelectorAll('[data-module="scroll-rig"]')

if (rigEl.length > 0) {
  import('./components/scroll-rig')
    .then(({ scrollRig }) => {
			rigEl.forEach(rig => {
				scrollRig(rig)
			})
		})
}

// --------------------------------
// Auto play videos when they are in the viewport
// --------------------------------
const videos = document.querySelectorAll('[data-module="autoplay-video"]')

if (videos.length > 0) {
  import('./components/video-observer')
    .then(({ videoObserver }) => {
			videos.forEach(video => {
				videoObserver(video)
			})
		})
}

// --------------------------------
// Scroll to a target (with smooth scroll)
// --------------------------------
const scrollToTriggers = document.querySelectorAll('[data-module="scroll-to"]')

if (scrollToTriggers.length > 0) {
  import('./components/scroll-to')
    .then(({ scrollTo }) => {
			scrollToTriggers.forEach(trigger => {
				scrollTo(trigger)
			})
		})
}

// --------------------------------
// Animate marquees
// --------------------------------
const marquees = document.querySelectorAll('[data-module="marquee"]')

if (marquees.length > 0) {
  import('./animation/marquee')
    .then(({ marqueeAnimation }) => {
			marquees.forEach(marquee => {
				marqueeAnimation(marquee)
			})
		})
}

// --------------------------------
// Events carousel
// --------------------------------
const eventsCarousels = document.querySelectorAll('[data-module="events-carousel"]')

if (eventsCarousels.length > 0) {
  import('./components/events-carousel')
    .then(({ eventsCarousel }) => {
			eventsCarousels.forEach(carousel => {
				eventsCarousel(carousel)
			})
		})
}

// --------------------------------
// Gallery carousel
// --------------------------------
const galleryCarousels = document.querySelectorAll('[data-module="gallery-carousel"]')

if (galleryCarousels.length > 0) {
  import('./components/gallery-carousel')
    .then(({ galleryCarousel }) => {
			galleryCarousels.forEach(carousel => {
				galleryCarousel(carousel)
			})
		})
}

// --------------------------------
// Rules hero
// --------------------------------
const rulesHeroEls = document.querySelectorAll('[data-module="rules-hero"]')

if (rulesHeroEls.length > 0) {
  import('./components/rules-hero')
    .then(({ rulesHero }) => {
			rulesHeroEls.forEach(hero => {
				rulesHero(hero)
			})
		})
}

// --------------------------------
// News hero
// --------------------------------
const newsHeroEls = document.querySelectorAll('[data-module="news-hero"]')

if (newsHeroEls.length > 0) {
  import('./components/news-hero')
    .then(({ newsHero }) => {
			newsHeroEls.forEach(hero => {
				newsHero(hero)
			})
		})
}

// --------------------------------
// Single News hero
// --------------------------------
const singleNewsHeroEls = document.querySelectorAll('[data-module="single-news-hero"]')

if (singleNewsHeroEls.length > 0) {
  import('./components/single-news-hero')
    .then(({ singleNewsHero }) => {
			singleNewsHeroEls.forEach(hero => {
				singleNewsHero(hero)
			})
		})
}

// --------------------------------
// Animate news cards on facetWP filter
// --------------------------------
const newsLists = document.querySelectorAll('[data-animation="news-list"]')

if (newsLists.length > 0) {
  import('./animation/news-list')
    .then(({ newsListAnimation }) => {
			newsLists.forEach(list => {
				newsListAnimation(list)
			})
		})
}